module.exports = __webpack_public_path__ + "assets/img/sign.64b90c2e.png";